module.exports = "/images/778ba4c7c7992511df85b5b1839bd147.svg";